import * as React from 'react';
import clsx from 'clsx';

import styles from './styles/Stats.module.scss';

const Stats = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div className={clsx(styles.stats, className)} data-cxy-name="stats" ref={ref} {...props} />
));

const StatsItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { title: string; value: string }
>(({ 'aria-label': ariaLabel, className, title, value, ...props }, ref) => (
  <div
    className={clsx(styles.statsItem, className)}
    ref={ref}
    {...props}
    aria-label={ariaLabel}
    data-testid="stats-item"
  >
    <p aria-hidden={ariaLabel ? true : false} className={styles.statsItemValue}>
      {value}
    </p>
    <p aria-hidden={ariaLabel ? true : false} className={styles.statsItemTitle}>
      {title}
    </p>
  </div>
));

Stats.displayName = 'Stats';
StatsItem.displayName = 'StatsItem';

export { Stats, StatsItem };
